/* ═══════════════════════════════════════════════════════════
   PK30 · 全息箔光引擎
   數學與參數沿用 simeydotme/pokemon-cards-css（GPL-3.0）公開手法，
   實作為自行撰寫：
     rot = ±(center / 3.5)                     → 最大約 ±14.3°
     bg  = remap(percent, 0..100 → 37..63 / 33..67)  ← 幅度刻意受限
     spring: stiffness .066 / damping .25
   背景位移只走中段而非全幅，是箔光看起來像「反光」而不是「貼圖平移」的原因。
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(v, lo, hi) { return Math.min(Math.max(v, lo), hi); }
  function round(v, p) { return parseFloat(v.toFixed(p === undefined ? 3 : p)); }
  function remap(v, a1, a2, b1, b2) { return b1 + (b2 - b1) * (v - a1) / (a2 - a1); }

  var STIFF = 0.066, DAMP = 0.25;
  /* 放手後把手指的甩動速度注入彈簧 → 卡片會續轉一下再回正（慣性）。
     位移總量 ≈ vel / DAMP，所以 FLICK 要小；上限避免暴衝。 */
  var FLICK = 0.9, FLICK_MAX = 3;

  function Spring(v) { this.v = v; this.t = v; this.vel = 0; }
  Spring.prototype.step = function () {
    var d = this.t - this.v;
    this.vel = (this.vel + d * STIFF) * (1 - DAMP);
    this.v += this.vel;
    if (Math.abs(d) < 0.008 && Math.abs(this.vel) < 0.008) {
      this.v = this.t; this.vel = 0; return false;
    }
    return true;
  };

  var TILTABLE = [];

  function bind(el) {
    if (el.dataset.pk30Bound) return;
    el.dataset.pk30Bound = '1';

    var rotX = new Spring(0), rotY = new Spring(0);
    var bgX = new Spring(50), bgY = new Spring(50);
    var ptX = new Spring(50), ptY = new Spring(50);
    var shine = new Spring(0);
    var all = [rotX, rotY, bgX, bgY, ptX, ptY, shine], raf = 0;

    function frame() {
      var moving = false, i;
      for (i = 0; i < all.length; i++) { if (all[i].step()) moving = true; }
      var px = ptX.v, py = ptY.v;
      var fc = Math.min(1, Math.sqrt((px - 50) * (px - 50) + (py - 50) * (py - 50)) / 50);
      var st = el.style;
      st.setProperty('--rot-x', round(rotX.v, 2) + 'deg');
      st.setProperty('--rot-y', round(rotY.v, 2) + 'deg');
      st.setProperty('--pointer-x', round(px, 2) + '%');
      st.setProperty('--pointer-y', round(py, 2) + '%');
      st.setProperty('--bg-x', round(bgX.v, 2) + '%');
      st.setProperty('--bg-y', round(bgY.v, 2) + '%');
      st.setProperty('--from-left', round(clamp(px, 0, 100) / 100));
      st.setProperty('--from-top', round(clamp(py, 0, 100) / 100));
      st.setProperty('--from-center', round(fc));
      st.setProperty('--shine-o', round(shine.v));
      raf = moving ? requestAnimationFrame(frame) : 0;
    }
    function kick() { if (!raf) raf = requestAnimationFrame(frame); }

    function aim(px, py) {
      px = clamp(px, 0, 100); py = clamp(py, 0, 100);
      rotY.t = -((px - 50) / 3.5);
      rotX.t = ((py - 50) / 3.5);
      bgX.t = remap(px, 0, 100, 37, 63);
      bgY.t = remap(py, 0, 100, 33, 67);
      ptX.t = px; ptY.t = py; shine.t = 1;
      kick();
    }
    function rest() {
      rotX.t = 0; rotY.t = 0; bgX.t = 50; bgY.t = 50;
      ptX.t = 50; ptY.t = 50; shine.t = 0; kick();
    }
    el._aim = aim; el._rest = rest;
    TILTABLE.push(el);

    /* 卡單裡的小卡不吃拖曳 —— 手機上那裡的滑動是要捲頁面 */
    var isTile = !!(el.closest('.pk-tile') || el.closest('.pk-drum'));
    el._pk30Tile = isTile;

    if (!reduce) {
      var drag = null;

      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        if (e.pointerType === 'mouse') {
          aim(100 / r.width * (e.clientX - r.left), 100 / r.height * (e.clientY - r.top));
          return;
        }
        if (!drag || e.pointerId !== drag.id) return;
        var now = e.timeStamp || Date.now();
        var dt = Math.max(1, now - drag.t);
        /* px/ms —— 用來算放手時的衝量 */
        drag.vx = (e.clientX - drag.x) / dt;
        drag.vy = (e.clientY - drag.y) / dt;
        drag.x = e.clientX; drag.y = e.clientY; drag.t = now;
        drag.moved = true;
        aim(100 / r.width * (e.clientX - r.left), 100 / r.height * (e.clientY - r.top));
      }, { passive: true });

      el.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'mouse') rest();
      });

      if (!isTile) {
        el.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse') return;
          drag = { id: e.pointerId, x: e.clientX, y: e.clientY,
                   t: e.timeStamp || Date.now(), vx: 0, vy: 0, moved: false };
          touchHold++;
          try { el.setPointerCapture(e.pointerId); } catch (err) { }
          var r = el.getBoundingClientRect();
          aim(100 / r.width * (e.clientX - r.left), 100 / r.height * (e.clientY - r.top));
        }, { passive: true });

        var release = function (e) {
          if (!drag || (e && e.pointerId !== drag.id)) return;
          if (drag.moved) {
            /* 甩出去的慣性：方向與 aim() 的換算一致（rotY 對 x 取負） */
            rotY.vel += clamp(-drag.vx * FLICK, -FLICK_MAX, FLICK_MAX);
            rotX.vel += clamp(drag.vy * FLICK, -FLICK_MAX, FLICK_MAX);
          }
          drag = null;
          touchHold = Math.max(0, touchHold - 1);
          gyroResumeAt = Date.now() + 1200;   /* 放手後先讓慣性跑完，再交回體感 */
          rest();
        };
        el.addEventListener('pointerup', release, { passive: true });
        el.addEventListener('pointercancel', release, { passive: true });
      } else {
        el.addEventListener('pointercancel', rest);
      }
    }

    /* 雙面卡（裸卡／鑑定殼）：點一下切換 */
    if (el.classList.contains('pk-card--dual')) {
      el.addEventListener('click', function () {
        setMode(el, el.dataset.mode === 'psa' ? 'raw' : 'psa');
      });
    }
  }

  function setMode(el, mode) {
    var was = el.dataset.mode;
    el.dataset.mode = mode;

    /* ══ 「裝殼」動畫（老闆 2026-09-20：點成 PSA 10 想要很酷的特效）══
       只在 raw → psa 這個方向播：卡片縮一下、殼扣上來、壓克力掃過一道反光、
       標籤最後亮一下。反方向（拆殼）不播，不然來回點會一直閃。
       ⚠️ 用「移除 class → 強制 reflow → 再加回來」重啟動畫；
          只設一次 class 的話第二次點不會重播。 */
    if (mode === 'psa' && was === 'raw' && !reduce) {
      el.classList.remove('is-slabbing');
      void el.offsetWidth;
      el.classList.add('is-slabbing');
      clearTimeout(el._slabT);
      el._slabT = setTimeout(function () { el.classList.remove('is-slabbing'); }, 1350);
    }
    if (!el.id) return;
    var btns = document.querySelectorAll('.pk-mode-btn[data-target="' + el.id + '"]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', String(btns[i].dataset.mode === mode));
    }
  }

  /* ── 手機：傾斜裝置驅動箔光 ──
     手指正在拖曳（或剛放手、慣性還在跑）時不要搶，否則兩股輸入會打架。 */
  var touchHold = 0, gyroResumeAt = 0;
  var gyroOn = false;
  function enableGyro() {
    if (gyroOn) return; gyroOn = true;
    var base = null;
    window.addEventListener('deviceorientation', function (e) {
      if (e.gamma === null || e.beta === null) return;
      if (touchHold > 0 || Date.now() < gyroResumeAt) return;
      if (!base) base = { b: e.beta, g: e.gamma };
      /* ⚠️ 傾斜幅度：±15 度就吃滿整個效果（老闆 2026-09-20：「手機不用動太多
         就可以有比較多效果」）。原本是 ±32 度 —— 要把手機翻快一半才看得到滿版箔光，
         實際拿在手上根本不會轉那麼多。數字調小＝越敏感。 */
      var TILT = 15;
      var px = remap(clamp(e.gamma - base.g, -TILT, TILT), -TILT, TILT, 0, 100);
      var py = remap(clamp(e.beta - base.b, -TILT, TILT), -TILT, TILT, 0, 100);
      for (var i = 0; i < TILTABLE.length; i++) {
        var el = TILTABLE[i], r = el.getBoundingClientRect();
        /* ⚠️⚠️ 卡單縮圖（.pk-tile 裡的卡）一律不吃體感（2026-09-22 客人回報）。
           iPhone 開啟體感後捲到卡單，會有一張縮圖突然被放大到二十幾倍、蓋滿整個畫面，
           還跟著手機傾斜移動，只能拉控制中心逃離。
           查證：同一條陀螺儀路徑在 Chrome 驅動，卡片只轉 −11°／−13.7°、外框 140×235 → 147×237，
           幾何完全正確 —— 是 **iOS Safari（WebKit）** 在「格線裡同時有好幾張 3D 旋轉的卡
           （perspective + translate3d + color-dodge 箔光）被高頻更新」時的合成層渲染 bug，
           不是我們算錯，CSS 修不掉。
           主視覺與商品頁的大卡照常吃體感（那兩處本來就正常，影片裡也沒出事）；
           卡單縮圖在桌機仍有滑鼠 hover 的箔光與傾斜，手機上捲動時本來就不該跟著晃。 */
        if (el._pk30Tile) continue;
        if (r.bottom < 0 || r.top > window.innerHeight) continue;  /* 只驅動畫面內的卡 */
        if (r.width < 90) continue;                                /* 太小的縮圖不用跟著晃 */
        el._aim(px, py);
      }
    }, { passive: true });
  }

  function init(root) {
    root = root || document;

    root.querySelectorAll('.pk-card').forEach(bind);

    root.querySelectorAll('.pk-mode-btn').forEach(function (b) {
      if (b.dataset.pk30Bound) return;
      b.dataset.pk30Bound = '1';
      b.addEventListener('click', function () {
        var t = document.getElementById(b.dataset.target);
        if (t) setMode(t, b.dataset.mode);
      });
    });

    /* ── 稀有度篩選 ── */
    var filters = root.querySelector('[data-pk30-filters]');
    if (filters && !filters.dataset.pk30Bound) {
      filters.dataset.pk30Bound = '1';
      var grid = document.querySelector('[data-pk30-grid]');
      filters.querySelectorAll('.pk-filter').forEach(function (b) {
        b.addEventListener('click', function () {
          var k = b.dataset.filter;
          filters.querySelectorAll('.pk-filter').forEach(function (x) {
            x.setAttribute('aria-pressed', String(x === b));
          });
          if (!grid) return;
          /* ⚠️ 以前是逐張 `t.hidden = true`，但 `.pk-tile{display:flex}` 是作者樣式，
             會蓋過瀏覽器預設的 `[hidden]{display:none}` → 按了完全沒反應。
             現在改成切整個稀有度區塊，CSS 也補了 `[hidden]{display:none!important}`。 */
          var groups = grid.querySelectorAll('[data-rarity-group]');
          if (groups.length) {
            groups.forEach(function (g) {
              g.hidden = !(k === 'all' || g.dataset.rarityGroup === k);
            });
          } else {
            grid.querySelectorAll('.pk-tile').forEach(function (t) {
              t.hidden = !(k === 'all' || t.dataset.rarity === k);
            });
          }
        });
      });
    }

    /* ── 商品圖庫：裸卡／鑑定殼／對比圖 ── */
    var gal = root.querySelector('[data-pk30-gallery]');
    if (gal && !gal.dataset.pk30Bound) {
      gal.dataset.pk30Bound = '1';
      var views = gal.querySelectorAll('.pk-gal__view');
      var thumbs = gal.querySelectorAll('.pk-gal__thumb');

      /* 掛在元素上，讓「選規格」也能切圖（選連號 SET → 自動換成兩張的合成圖）。
         合成動畫不必自己觸發：.pk-gal__view 是 display:none↔block，
         一變回 block CSS animation 就會從頭重播。 */
      gal._show = function (v) {
        var hit = false;
        thumbs.forEach(function (x) {
          var on = x.dataset.view === v;
          if (on) hit = true;
          x.setAttribute('aria-pressed', String(on));
          x.classList.toggle('is-on', on);
        });
        if (!hit) return false;
        views.forEach(function (x) { x.classList.toggle('is-on', x.dataset.view === v); });
        var card = gal.querySelector('.pk-gal__view.is-on .pk-card');
        if (card && card._rest) card._rest();
        return true;
      };
      gal._current = function () {
        var on = gal.querySelector('.pk-gal__view.is-on');
        return on ? on.dataset.view : null;
      };

      /* 切到某個視圖，規格跟著走：
           連號 SET 的圖 → 選連號 SET 規格
           單張的圖      → 切回單張規格
         ⚠️ 兩個方向都要做（老闆 2026-09-20 回報：「切回去前面兩張卡片，價格沒變回去」）。
         只換圖不換規格的話，畫面是一張、價格卻停在兩張的價，客人會以為壞了。 */
      function pick(view) {
        if (!gal._show(view)) return;
        selectVariant(view === 'set'
          ? function (v) { return v.isSet; }
          : function (v) { return !v.isSet; });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { pick(t.dataset.view); });
      });

      /* 左右懸浮箭頭：照縮圖的順序循環 */
      var order = [];
      thumbs.forEach(function (t) { order.push(t.dataset.view); });
      var navs = gal.querySelectorAll('[data-pk30-gal-nav]');
      if (order.length < 2) {
        navs.forEach(function (n) { n.hidden = true; });
      } else {
        navs.forEach(function (n) {
          n.addEventListener('click', function () {
            var step = parseInt(n.getAttribute('data-pk30-gal-nav'), 10) || 1;
            var now = order.indexOf(gal._current());
            if (now < 0) now = 0;
            pick(order[(now + step + order.length) % order.length]);
          });
        });
        /* 鍵盤左右鍵也能翻 —— 焦點在圖庫裡才生效，不然會搶走整頁的方向鍵 */
        gal.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          var now = order.indexOf(gal._current());
          if (now < 0) now = 0;
          pick(order[(now + (e.key === 'ArrowRight' ? 1 : -1) + order.length) % order.length]);
        });
      }
    }

    /* ── 捲過購買區後才出現的固定購買列 ── */
    var bar = document.querySelector('[data-pk30-buybar]');
    var zone = root.querySelector('[data-pk30-buyzone]');
    if (bar && zone && !bar.dataset.pk30Bound) {
      bar.dataset.pk30Bound = '1';
      var barCta = bar.querySelector('[data-pk30-buybar-cta]');
      if (barCta) {
        barCta.addEventListener('click', function () {
          var real = zone.querySelector('.pk-cta');
          if (!real) return;
          if (real.form) { real.click(); }
          else { zone.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        });
      }

      /* 吸底列直接選規格。
         ⚠️ 真相還是選購 app 那邊的 input[name="id"] —— 這裡只是遙控器：
         點膠囊 → selectVariant() 去點上面那顆真的選項 → initVariantPrice() 同步價格。
         自己另外記一份狀態一定會跟 app 不同步（老闆會看到價格跟規格對不起來）。 */
      var opts = bar.querySelectorAll('[data-pk30-buybar-opt]');
      if (opts.length) {
        var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        function paint() {
          var now = idInput ? String(idInput.value) : '';
          for (var i = 0; i < opts.length; i++) {
            opts[i].setAttribute('aria-pressed', String(opts[i].dataset.pk30BuybarOpt === now));
          }
        }
        opts.forEach(function (b) {
          b.addEventListener('click', function () {
            var want = b.dataset.pk30BuybarOpt;
            selectVariant(function (v) { return String(v.id) === String(want); });
            setTimeout(paint, 120);
          });
        });
        paint();
        /* app 是非同步的，而且客人也可能在上面自己改 —— 低頻輪詢保持一致 */
        setInterval(paint, 600);
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          var e = entries[0];
          /* 購買區還看得到就不用重複出現一次 CTA */
          var show = !e.isIntersecting && e.boundingClientRect.top < 0;
          /* 只切 class —— 用 hidden 會變 display:none，transform 動畫就不會播 */
          bar.classList.toggle('is-on', show);
          bar.setAttribute('aria-hidden', String(!show));
        }, { rootMargin: '0px 0px -40% 0px' });
        io.observe(zone);
      }
    }
  }

  /* ── 變體價格同步 ──
     選購 app（Globo）切換規格時只改 input[name="id"]，不會發 change，也不會動我們的價格。
     所以這裡自己盯著 id：先掛事件，再加一個低頻輪詢當保險。 */
  function initVariantPrice() {
    var data = document.querySelector('[data-pk30-variants]');
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!data || !form || form.dataset.pk30Price) return;
    var idIn = form.querySelector('input[name="id"]');
    /* ⚠️ 只認「沒有子節點的 span」——選購 app 會把自訂屬性複製到 <form> 上，
       要是把 form 當成目標寫 textContent，整張表單會被一行字蓋掉、直接不能買。 */
    var targets = [];
    var all = document.querySelectorAll('[data-pk30-price]');
    for (var k = 0; k < all.length; k++) {
      if (all[k].tagName === 'SPAN' && all[k].children.length === 0) targets.push(all[k]);
    }
    if (!idIn || !targets.length) return;

    var map = {};
    try {
      JSON.parse(data.textContent).forEach(function (v) { map[String(v.id)] = v; });
    } catch (e) { return; }
    if (!Object.keys(map).length) return;
    form.dataset.pk30Price = '1';

    /* 把價格與說明塞進選購 app 的選項裡 —— 讓客人不用切換就看得到價差。
       app 是非同步渲染的，所以每輪都試一次（已處理過的會被 guard 擋掉）。 */
    function decorate() {
      var lis = document.querySelectorAll('[data-pk30-buyzone] li[data-variantid]');
      for (var i = 0; i < lis.length; i++) {
        var v = map[String(lis[i].getAttribute('data-variantid'))];
        if (!v) continue;
        var lab = lis[i].querySelector('label');
        if (!lab || lab.querySelector('.pk-opt-price')) continue;
        if (v.note) {
          var n = document.createElement('span');
          n.className = 'pk-opt-note';
          n.textContent = v.note;
          lab.appendChild(n);
        }
        var pr = document.createElement('span');
        pr.className = 'pk-opt-price';
        pr.textContent = v.price;
        lab.appendChild(pr);
      }
    }

    /* 選到連號 SET → 下方兩張卡合併成一組，主圖也換成兩張的合成圖 */
    function syncPair(v, isFirstRun) {
      var isSet = !!(v && v.isSet);
      var pair = document.querySelector('.pk-pair');
      if (pair) pair.classList.toggle('is-set', isSet);

      var gal = document.querySelector('[data-pk30-gallery]');
      if (!gal || !gal._show) return;
      if (isFirstRun) return;              /* 第一次載入不要硬切 */
      if (isSet) gal._show('set');
      else if (gal._current() === 'set') gal._show('psa');
    }

    var last = String(idIn.value);
    /* ⚠️ 第一次就要把價格寫上去。客人可能是帶著 ?variant=<連號 SET> 直接進來的
       （分享連結、購物車回來、上次看的規格），這時 Liquid 印的是「預設變體」的價格＝單張價，
       畫面上規格寫「連號 SET」、價格卻是 $7,880。sync() 因為 now === last 直接 return，
       永遠補不上。老闆 2026-09-20 回報的就是這一個。 */
    (function () {
      var v0 = map[last];
      if (!v0) return;
      for (var i = 0; i < targets.length; i++) targets[i].textContent = v0.price;
    })();
    syncPair(map[last], true);
    function sync() {
      decorate();
      var now = String(idIn.value);
      if (now === last) return;
      var v = map[now];
      if (!v) return;
      last = now;
      for (var i = 0; i < targets.length; i++) targets[i].textContent = v.price;
      syncPair(v);
    }
    form.addEventListener('change', sync);
    /* app 的選項多半是 label/radio，點下去到改值之間有一小段 */
    form.addEventListener('click', function () { setTimeout(sync, 80); });
    setInterval(sync, 600);
  }

  /* ══ 卡單快速加購 ══
     老闆 2026-09-20：卡單上要能直接加入購物車。
     ⚠️ 走 /cart/add.js，成功後把迷你購物車叫出來（跟商品頁同一套流程）。
     ⚠️ 有兩個變體（連號 SET）的卡不給快速加購 —— 那種要先選規格，
        Liquid 那邊已經改成渲染「選規格」的連結，不會有 data-pk30-quickadd。
     ⚠️ 加完不要跳結帳（[[kpanda-no-direct-checkout]]）—— 取件資訊只有 /cart 填得到。 */
  function initQuickAdd() {
    var btns = document.querySelectorAll('[data-pk30-quickadd]');
    if (!btns.length || !window.fetch) return;
    btns.forEach(function (b) {
      if (b.dataset.pk30Bound) return;
      b.dataset.pk30Bound = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();          /* 不要讓整張卡的連結跟著跳頁 */
        if (b.disabled) return;
        var id = b.dataset.pk30Quickadd;
        var label = b.textContent;
        b.disabled = true;
        b.textContent = '加入中…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            b.classList.add('is-done');
            b.textContent = '已加入 ✓';
            var cart = document.querySelector('[data-pk30-cart]');
            if (cart && cart._pk30Refresh) cart._pk30Refresh();
            setTimeout(function () {
              b.classList.remove('is-done');
              b.textContent = label;
              b.disabled = false;
            }, 1800);
          })
          .catch(function () {
            b.textContent = '加入失敗';
            setTimeout(function () { b.textContent = label; b.disabled = false; }, 1600);
          });
      });
    });
  }

  /* ══ 價目表燈箱 ══
     老闆 2026-09-20：「點開就可以直接看到完整的價目表，不要再導到他們網站，
     停留在我們網站就好，也要記得做 X 叉叉給我們按關閉」。
     圖片是主題自己的 assets，不是熱連結外站。
     ⚠️ 沒有 JS 的話那顆還是 <a href="圖片">，照樣看得到 —— 所以這裡是漸進增強，
     只在攔得到 click 的時候才改成燈箱。 */
  function initPriceBox() {
    var box = document.querySelector('[data-pk30-plbox]');
    if (!box || box.dataset.pk30Bound) return;
    box.dataset.pk30Bound = '1';

    var body = box.querySelector('[data-pk30-plbox-body]');
    var title = box.querySelector('.pk-plbox__title');
    var lastFocus = null;

    function close() {
      box.hidden = true;
      body.innerHTML = '';
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      lastFocus = null;
    }

    function open(urls, label, trigger) {
      lastFocus = trigger || null;
      title.textContent = label || '完整價目';
      body.innerHTML = '';
      urls.forEach(function (u, i) {
        var img = document.createElement('img');
        img.className = 'pk-plbox__img';
        img.src = u;
        img.alt = (label || '價目表') + (urls.length > 1 ? ' 第 ' + (i + 1) + ' 頁' : '');
        img.loading = i === 0 ? 'eager' : 'lazy';
        body.appendChild(img);
      });
      box.hidden = false;
      body.scrollTop = 0;
      /* 背景鎖捲動 —— 不然手指在圖上滑會連帶把後面的頁面捲走 */
      document.documentElement.style.overflow = 'hidden';
      var x = box.querySelector('.pk-plbox__x');
      if (x && x.focus) x.focus();
    }

    document.querySelectorAll('[data-pk30-price]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        var raw = a.dataset.pk30Price || '';
        var urls = raw.split(',').map(function (u) { return u.trim(); }).filter(Boolean);
        if (!urls.length) return;
        e.preventDefault();
        open(urls, a.dataset.pk30PriceTitle, a);
      });
    });

    box.querySelectorAll('[data-pk30-plbox-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (!box.hidden && (e.key === 'Escape' || e.key === 'Esc')) close();
    });
  }

  /* ══ 主視覺換卡（r131 ↔ r132）══
     只是把幾張 .pk-hero__slide 疊在一起，一次顯示一張。
     ⚠️ 卡片本身完全沒動 —— 大小、箔光、3D、PSA 10／卡面 切換都還是原本那一套
     （老闆 2026-09-20：「卡片大小、互動方式那些都保持跟原本一樣不要動」）。
     切換時要做兩件事：
       1. 把模式鈕的 data-target 指到新的那張卡，不然按 PSA 10／卡面 會改到藏起來的那張
       2. 新的那張卡沿用當前的模式（別人看到一半切過去不該跳回 PSA） */
  function initHeroDeck() {
    var deck = document.querySelector('[data-pk30-herodeck]');
    if (!deck || deck.dataset.pk30Bound) return;
    deck.dataset.pk30Bound = '1';

    var slides = deck.querySelectorAll('[data-pk30-heroslide]');
    if (slides.length < 2) return;
    var dots = document.querySelectorAll('[data-pk30-hero-dot]');
    var modeBtns = document.querySelectorAll('.pk-mode-btn[data-target^="pk30Hero"]');
    var cur = 0;

    function currentMode() {
      for (var i = 0; i < modeBtns.length; i++) {
        if (modeBtns[i].getAttribute('aria-pressed') === 'true') return modeBtns[i].dataset.mode;
      }
      return 'psa';
    }

    function show(n) {
      var len = slides.length;
      n = ((n % len) + len) % len;
      cur = n;
      var mode = currentMode();
      for (var i = 0; i < len; i++) slides[i].classList.toggle('is-on', i === n);
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', d === n);

      var card = slides[n].querySelector('.pk-card');
      var id = card ? card.id : null;
      if (id) {
        for (var b = 0; b < modeBtns.length; b++) modeBtns[b].dataset.target = id;
        if (card.dataset.mode !== mode) card.dataset.mode = mode;
      }
      /* 換過去的那張要回到靜止角度，不然會停在上一次滑鼠離開時的傾斜 */
      if (card && card._rest) card._rest();
    }

    deck.querySelectorAll('[data-pk30-hero-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        show(cur + (parseInt(btn.dataset.pk30HeroNav, 10) || 1));
      });
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.pk30HeroDot, 10) || 0);
      });
    });
    show(0);
  }

  /* 回到最上面：沒有 JS 就不顯示這顆鈕（不留一顆點了沒反應的按鈕）。 */
  function initTop() {
    var els = document.querySelectorAll('[data-pk30-top]');
    for (var i = 0; i < els.length; i++) {
      (function (el) {
        if (el.dataset.pk30Bound) return;
        el.dataset.pk30Bound = '1';
        el.hidden = false;
        el.addEventListener('click', function () {
          window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
        });
      })(els[i]);
    }
  }

  /* 返回上一頁：只有「上一頁是站內、而且不是自己」才攔截成 history.back()，
     否則就讓 <a href> 原樣運作（直接開連結、新分頁、右鍵都正常）。 */
  /* 「返回卡單」= 一律回到卡單頁，不要猜「上一頁」。
     ⚠️ 舊版會在「referrer 是站內」時攔成 history.back()，結果客人如果是
     卡單 → A 卡 → 同系列輪播 → B 卡 這樣逛過來的，按返回就回到 A 卡而不是卡單，
     老闆 2026-09-20 回報「按下返回卡單好像不會回到 /pages/pokemon-30th」。
     按鈕上寫的是「返回卡單」，那就老老實實走 <a href> —— 目的地才會是確定的。
     （購物車那條返回列是另一支 inline script，它要回的是「剛剛那張商品」，行為不同，不要一起改。） */
  function initBack() { /* 不再攔截，保留函式讓 boot() 的呼叫不用改 */ }

  /* ══ 滾筒展示（首頁 hero）══
     卡片排在一根水平軸心上，像垂直的翻頁鐘。
     物理：每幀「棘輪彈簧 + 阻尼」——
       vel += (target - pos) * DETENT   ← 棘輪：永遠往最近的一張拉，轉快時會一格一格頓
       vel *= DAMP                      ← 阻尼：放手後慢慢停
     輸入：頁面捲動速度、直接上下拖曳、上下鍵、左右箭頭鈕。
     ⚠️ 捲動用 passive listener，絕對不要 preventDefault —— 那會讓頁面捲不動。 */
  function initDrum() {
    var drum = document.querySelector('[data-pk30-drum]');
    if (!drum || drum.dataset.pk30Bound) return;
    drum.dataset.pk30Bound = '1';

    var cells = [].slice.call(drum.querySelectorAll('.pk-drum__cell'));
    var n = cells.length;
    if (!n) return;
    var countEl = document.querySelector('[data-pk30-drum-count]');

    var STEP = 58;        /* 相鄰兩張的夾角 */
    var DAMP = 0.82;      /* 阻尼：每幀保留多少速度 */
    var DETENT = 0.14;    /* 棘輪強度 */
    var MAXV = 0.62;      /* 單幀最多轉幾張，不然會糊成一團 */

    var pos = 0, vel = 0, raf = 0, want = null, dragging = false;
    /* hovering：滑鼠正在帶著轉，這段期間不要讓棘輪插手 */

    function wrap(off) {
      if (off > n / 2) off -= n;
      if (off < -n / 2) off += n;
      return off;
    }
    function render() {
      /* ⚠️ 軸心是「垂直」的，卡片左右繞著轉（老闆 2026-09-20：滾輪是左右滾不是上下滾）。
         所以半徑要用卡片「寬度」反推，卡與卡才會剛好接在圓筒面上。 */
      var R = (cells[0].clientWidth || drum.clientWidth) * 0.5 / Math.tan(STEP * Math.PI / 360);
      for (var i = 0; i < n; i++) {
        var off = wrap(i - pos);
        var c = cells[i];
        if (Math.abs(off) > 2.2) { c.style.visibility = 'hidden'; continue; }
        var a = off * STEP;
        var fade = Math.min(1, Math.abs(off) / 1.55);
        c.style.visibility = 'visible';
        c.style.transform = 'rotateY(' + a + 'deg) translateZ(' + R.toFixed(1) + 'px)';
        c.style.zIndex = String(200 - Math.round(Math.abs(off) * 20));
        c.style.opacity = (1 - fade * 0.78).toFixed(3);
        c.style.filter = 'brightness(' + (1 - fade * 0.58).toFixed(3) + ')';
        /* 側邊的卡也要點得到（點了就轉到那一張）；只有看不見的才關掉 */
        c.style.pointerEvents = 'auto';
        c.style.cursor = Math.abs(off) < 0.5 ? 'grab' : 'pointer';
      }
      if (countEl) {
        var idx = ((Math.round(pos) % n) + n) % n;
        countEl.textContent = (idx + 1) + ' / ' + n;
      }
    }
    function tick() {
      raf = 0;
      if (!dragging && !hovering) {
        var target = (want === null) ? Math.round(pos) : want;
        vel += (target - pos) * DETENT;
        vel *= DAMP;
        if (vel > MAXV) vel = MAXV;
        if (vel < -MAXV) vel = -MAXV;
        pos += vel;
        if (Math.abs(vel) < 0.0007 && Math.abs(target - pos) < 0.001) {
          pos = target; want = null; vel = 0; render(); return;
        }
      }
      render();
      raf = requestAnimationFrame(tick);
    }
    function run() { if (!raf) raf = requestAnimationFrame(tick); }
    function kick(v) { want = null; vel += v; run(); }
    function stepTo(d) { want = Math.round(want === null ? pos : want) + d; run(); }

    if (reduce) {
      /* 尊重系統的「減少動態」：不轉，只做瞬間切換 */
      DAMP = 0; DETENT = 1;
    }

    /* ① 滑鼠在滾筒上左右移動 → 直接帶著它轉（不用按住）。
       這是主要的操作方式：手往右滑，滾筒就往右滾，放開後靠阻尼＋棘輪停在某一張。
       ⚠️ 不要綁「頁面捲動位置」—— 那是客人在捲頁面，不是在轉滾筒。 */
    var hoverX = null, hoverTimer = 0, hovering = false;
    drum.addEventListener('pointermove', function (e) {
      if (dragging) return;                      /* 按住拖曳時交給下面的 1:1 控制 */
      if (e.pointerType === 'touch') return;     /* 觸控沒有 hover，靠拖曳 */
      if (hoverX === null) { hoverX = e.clientX; return; }
      var w = drum.clientWidth || 1;
      var dx = e.clientX - hoverX;
      hoverX = e.clientX;
      /* ⚠️ 直接改 pos，不要「丟速度進去」——
         棘輪每幀都把角度拉回最近一張，小力道會被它吃光，滑鼠掃過去等於沒反應。
         掃過整個滾筒 ≈ 轉 1.6 張。 */
      hovering = true;
      want = null; vel = 0;
      pos -= dx / w * 1.6;
      render();
      if (hoverTimer) clearTimeout(hoverTimer);
      /* 停手一下下就交還給物理，讓它靠阻尼＋棘輪停在某一張 */
      hoverTimer = setTimeout(function () { hovering = false; run(); }, 110);
    });
    drum.addEventListener('pointerleave', function () {
      hoverX = null;
      if (hoverTimer) clearTimeout(hoverTimer);
      hovering = false; run();
    });

    /* ② 滾輪／觸控板橫向滑動也能轉 —— 不攔 preventDefault，頁面照樣捲得動 */
    drum.addEventListener('wheel', function (e) {
      var d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
      if (!d) return;
      kick(clamp(d * 0.0026, -0.45, 0.45));
    }, { passive: true });

    /* ② 直接上下拖曳 —— touch-action:pan-y 讓頁面照樣能捲 */
    var startY = 0, startPos = 0, lastY2 = 0, lastT = 0, flick = 0;
    drum.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; startY = e.clientX; startPos = pos;
      lastY2 = e.clientX; lastT = e.timeStamp; flick = 0; vel = 0; want = null;
      try { drum.setPointerCapture(e.pointerId); } catch (err) {}
      run();
    });
    drum.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var w = drum.clientWidth || 1;
      pos = startPos - (e.clientX - startX) / w * 1.15;
      /* 記住最近一小段的瞬時速度（px/ms），放手時才知道甩多用力 */
      var dt = e.timeStamp - lastT;
      if (dt > 0) {
        var inst = (e.clientX - lastY2) / dt;
        flick = flick * 0.6 + inst * 0.4;      /* 平滑一下，免得被單一跳動帶歪 */
        lastY2 = e.clientX; lastT = e.timeStamp;
      }
      render();
    });
    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      hoverX = null;
      try { drum.releasePointerCapture(e.pointerId); } catch (err) {}
      /* px/ms → 每幀轉幾張：乘一幀 16ms，再換算成卡片寬度的比例 */
      var w = drum.clientWidth || 1;
      kick(clamp(-flick * 16 / w * 1.15, -0.5, 0.5));
    }
    drum.addEventListener('pointerup', endDrag);
    drum.addEventListener('pointercancel', endDrag);

    /* ③ 上下鍵與箭頭鈕 */
    drum.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); stepTo(1); }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); stepTo(-1); }
    });
    var btns = document.querySelectorAll('[data-pk30-drum-step]');
    for (var b = 0; b < btns.length; b++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          stepTo(parseInt(btn.getAttribute('data-pk30-drum-step'), 10) || 1);
        });
      })(btns[b]);
    }

    /* ④ 點側邊的卡片 → 轉到那一張（正面那張不攔，留給箔光互動） */
    cells.forEach(function (c, i) {
      c.addEventListener('click', function () {
        var off = wrap(i - Math.round(pos));
        if (!off) return;
        stepTo(off);
      });
    });

    window.addEventListener('resize', render, { passive: true });
    render();
  }

  /* ══ 讓卡片圖不好被隨手存走 ══
     ⚠️ 網頁沒辦法真的防止存圖 —— 圖必須下載到瀏覽器才顯示，
     截圖、開發者工具、直接開 CDN 網址都繞得過。這裡擋掉的是「順手」那條路：
     右鍵另存、拖到桌面、手機長按跳選單。要真的防盜圖只能加浮水印或降解析度。 */
  function initImageGuard() {
    var zones = document.querySelectorAll('[data-pk30-gallery], .pk-pair, .pk-psa__vs, .pk-grid');
    if (!zones.length || document.documentElement.dataset.pk30Guard) return;
    document.documentElement.dataset.pk30Guard = '1';
    for (var i = 0; i < zones.length; i++) {
      zones[i].addEventListener('contextmenu', function (e) {
        if (e.target && e.target.closest && e.target.closest('a')) return;  /* 連結的選單留著 */
        e.preventDefault();
      });
    }
    /* 拖曳整頁都擋 —— 拖圖到桌面是最快的存圖法 */
    document.addEventListener('dragstart', function (e) {
      if (e.target && e.target.tagName === 'IMG') e.preventDefault();
    });
  }

  /* 依條件選一個變體（例如：連號 SET）。
     選項是選購 app 畫的，所以要從 li[data-variantid] 反查再點 label。 */
  function selectVariant(pred) {
    var data = document.querySelector('[data-pk30-variants]');
    if (!data) return false;
    var list;
    try { list = JSON.parse(data.textContent); } catch (e) { return false; }
    for (var i = 0; i < list.length; i++) {
      if (!pred(list[i])) continue;
      var li = document.querySelector('[data-pk30-buyzone] li[data-variantid="' + list[i].id + '"]');
      if (!li) return false;
      var hit = li.querySelector('label') || li.querySelector('input');
      if (!hit) return false;
      /* ⚠️ 點 <label> 會把焦點移到那顆隱藏的 radio，瀏覽器就自動把它捲進畫面 ——
         客人只是點縮圖想看圖，結果頁面自己跳到下面的規格區。
         先用 preventScroll 把焦點放好，再補一次位置還原當保險。 */
      var y = window.pageYOffset;
      var radio = li.querySelector('input[type="radio"]');
      if (radio && radio.focus) { try { radio.focus({ preventScroll: true }); } catch (e) {} }
      hit.click();
      if (window.pageYOffset !== y) window.scrollTo(0, y);
      setTimeout(function () {
        if (Math.abs(window.pageYOffset - y) > 2) window.scrollTo(0, y);
      }, 50);
      return true;
    }
    return false;
  }

  /* ── 展示櫃聚光燈 ── */
  function initSpot() {
    var spot = document.querySelector('[data-pk30-spot]');
    if (!spot || reduce || spot.dataset.pk30Bound) return;
    spot.dataset.pk30Bound = '1';
    window.addEventListener('pointermove', function (e) {
      spot.style.setProperty('--sx', (e.clientX / window.innerWidth * 100) + '%');
      spot.style.setProperty('--sy', (e.clientY / window.innerHeight * 100) + '%');
    }, { passive: true });
  }

  /* ══ 購物車預覽 + 免運進度 ══
     滑過（或聚焦）購物車就展開，看得到買了什麼、離免運還差多少。
     加入購物車改走 /cart/add.js：不跳頁、直接把抽屜打開。
     JS 掛掉時表單仍是原生 POST，照樣能買 —— 這是漸進增強，不是必要條件。 */
  function initCart() {
    var box = document.querySelector('[data-pk30-cart]');
    if (!box || box.dataset.pk30Bound) return;
    box.dataset.pk30Bound = '1';

    var link = box.querySelector('.pk-cartbtn__link');
    var panel = box.querySelector('[data-pk30-minicart]');
    var body = box.querySelector('[data-pk30-minicart-body]');
    var countEl = box.querySelector('[data-pk30-cart-count]');
    var cartUrl = box.getAttribute('data-cart-url') || '/cart';
    var freeMin = parseInt(box.getAttribute('data-free-min'), 10);
    if (isNaN(freeMin) || freeMin < 0) freeMin = 0;
    var assetBase = box.getAttribute('data-asset-base') || '';

    var closeTimer = null, loading = false, loaded = false;

    function money(cents) {
      /* Shopify 的金額一律是「分」。台幣沒有小數，除完直接加千分位。 */
      var n = Math.round(cents / 100);
      return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function esc(t) {
      return String(t == null ? '' : t)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function progressHtml(total) {
      if (!freeMin) return '';
      var pct = Math.min(100, Math.round(total / (freeMin * 100) * 100));
      var left = freeMin * 100 - total;
      var msg = left > 0
        ? '再買 <b>' + money(left) + '</b> 就免運'
        : '<b>已達免運門檻</b>';
      return '<div class="pk-ship-bar' + (left > 0 ? '' : ' is-done') + '">' +
        '<p class="pk-ship-bar__t">' + msg + '</p>' +
        '<div class="pk-ship-bar__track"><span style="width:' + pct + '%"></span></div>' +
        '</div>';
    }

    function render(cart) {
      if (countEl) countEl.textContent = cart.item_count;
      if (!cart.item_count) {
        body.innerHTML = '<p class="pk-minicart__empty">購物車是空的。</p>';
        return;
      }
      var rows = cart.items.map(function (it) {
        /* ⚠️ 這批商品目前沒有掛 Shopify 商品圖（item.image = null），
           卡面只存在主題 assets 裡。handle 是 pk30-<key>，檔名剛好推得出來，
           所以先用主題資產補上。→ 結帳頁是 Shopify 自己畫的，那裡還是空的，
           要根治一定要把 46 張圖掛成商品媒體。 */
        var src = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : null;
        if (!src && assetBase) {
          var m = /\/products\/pk30-([a-z0-9]+)/i.exec(it.url || '');
          if (m) src = assetBase + 'pk30-psa-' + m[1] + '.jpg';
        }
        var img = src
          ? '<img src="' + esc(src) + '" alt="" loading="eager" decoding="async">'
          : '<span class="pk-minicart__noimg"></span>';
        var opt = (it.variant_title && it.variant_title !== 'Default Title')
          ? '<span class="pk-minicart__opt">' + esc(it.variant_title) + '</span>' : '';
        return '<li class="pk-minicart__row">' +
          '<a class="pk-minicart__thumb" href="' + esc(it.url) + '">' + img + '</a>' +
          '<div class="pk-minicart__meta">' +
            '<a class="pk-minicart__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
            opt +
            '<span class="pk-minicart__qty">× ' + it.quantity + '</span>' +
          '</div>' +
          '<span class="pk-minicart__price">' + money(it.line_price) + '</span>' +
        '</li>';
      }).join('');

      body.innerHTML =
        '<ul class="pk-minicart__list">' + rows + '</ul>' +
        progressHtml(cart.total_price) +
        '<div class="pk-minicart__sum"><span>小計</span><b>' + money(cart.total_price) + '</b></div>' +
        /* ⚠️⚠️ 絕對不要放 /checkout 的直達連結（老闆 2026-09-20 明令）。
           取件門市／取件資訊是靠外掛畫在「整頁購物車」上的，
           直接跳結帳的人會整單缺取件資訊 → 付了錢卻出不了貨。
           全站任何地方要去結帳，一律先進 /cart。 */
        '<div class="pk-minicart__acts">' +
          '<a class="pk-minicart__go" href="' + esc(cartUrl) + '">前往購物車結帳</a>' +
        '</div>';
    }

    function load(force) {
      if (loading || (loaded && !force)) return Promise.resolve();
      loading = true;
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { loaded = true; render(c); })
        .catch(function () {
          body.innerHTML = '<p class="pk-minicart__empty">讀不到購物車，<a href="' +
            cartUrl + '">直接開啟</a>。</p>';
        })
        .then(function () { loading = false; });
    }

    function open() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      panel.hidden = false;
      /* ⚠️ 不要用 requestAnimationFrame —— 分頁在背景時 rAF 根本不會觸發，
         抽屜會永遠停在 opacity:0。強制回流一次就有 transition 的起點了。 */
      void panel.offsetWidth;
      box.classList.add('is-open');
      if (link) link.setAttribute('aria-expanded', 'true');
      load(false);
    }
    function close(delay) {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        box.classList.remove('is-open');
        if (link) link.setAttribute('aria-expanded', 'false');
        setTimeout(function () { if (!box.classList.contains('is-open')) panel.hidden = true; }, 200);
      }, delay === undefined ? 180 : delay);
    }

    /* 只有真的有滑鼠才用 hover —— 手機上 hover 會變成「點一下卡住」 */
    var canHover = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    if (canHover) {
      box.addEventListener('mouseenter', open);
      box.addEventListener('mouseleave', function () { close(); });
      box.addEventListener('focusin', open);
      box.addEventListener('focusout', function (e) {
        if (!box.contains(e.relatedTarget)) close(0);
      });
    } else if (link) {
      /* 觸控沒有 hover：點一下先開預覽，要看完整購物車面板裡有按鈕。
         不這樣做的話手機完全用不到這個預覽。 */
      link.addEventListener('click', function (e) {
        if (box.classList.contains('is-open')) return;   /* 已開著就讓它正常前往 /cart */
        e.preventDefault();
        open();
      });
      document.addEventListener('click', function (e) {
        if (box.classList.contains('is-open') && !box.contains(e.target)) close(0);
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.classList.contains('is-open')) close(0);
    });

    /* 讓卡單的快速加購也能叫得動這個抽屜（重新抓 /cart.js → 展開 → 自動收起） */
    box._pk30Refresh = function () {
      return load(true).then(function () {
        open();
        if (canHover) close(4000);
      });
    };

    /* 加入購物車：不跳頁，直接開抽屜 */
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form && !form.dataset.pk30Ajax) {
      form.dataset.pk30Ajax = '1';
      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.FormData) return;   /* 老瀏覽器走原生送出 */
        e.preventDefault();
        var btn = form.querySelector('.pk-cta');
        if (btn) { btn.disabled = true; btn.dataset.pk30Label = btn.textContent; btn.textContent = '加入中…'; }
        fetch('/cart/add.js', {
          method: 'POST', body: new FormData(form),
          headers: { 'Accept': 'application/json' }, credentials: 'same-origin'
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { return load(true); })
          .then(function () {
            open();
            /* 觸控裝置沒有滑鼠可以「移開」，自動收掉等於沒看到 —— 留著讓客人自己關 */
            if (canHover) close(4000);
          })
          .catch(function () { form.submit(); })      /* 失敗就退回原生送出，不要讓客人買不到 */
          .then(function () {
            if (btn) { btn.disabled = false; if (btn.dataset.pk30Label) btn.textContent = btn.dataset.pk30Label; }
          });
      });
    }
  }

  function boot() {
    init(document);
    initSpot();
    initVariantPrice();
    initCart();
    initDrum();
    initBack();
    initTop();
    initHeroDeck();
    initPriceBox();
    initQuickAdd();
    initImageGuard();
    if (!reduce) {
      var needsPerm = typeof DeviceOrientationEvent !== 'undefined' &&
        typeof DeviceOrientationEvent.requestPermission === 'function';
      var gbtns = document.querySelectorAll('.pk-gyro-btn');
      if (needsPerm && gbtns.length) {
        /* iOS 13+ 必須由使用者手勢觸發授權；頁面可能有多顆按鈕，授權後全部收起來 */
        var hideAll = function () {
          for (var j = 0; j < gbtns.length; j++) { gbtns[j].hidden = true; }
        };
        for (var i = 0; i < gbtns.length; i++) {
          gbtns[i].hidden = false;
          gbtns[i].addEventListener('click', function () {
            DeviceOrientationEvent.requestPermission().then(function (res) {
              if (res === 'granted') { enableGyro(); hideAll(); }
            }).catch(function () { });
          });
        }
      } else if (window.matchMedia('(hover:none)').matches) {
        enableGyro();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* 主題編輯器裡重新載入 section 後要重新綁定 */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); initVariantPrice(); });

  window.PK30 = { init: init, bind: bind, setMode: setMode };
})();
